module.exports = __webpack_public_path__ + "static/Jane-ad93123093f165fef90f92f575951ee3.png";